import { useEffect, useState, useCallback } from 'react'
import { feature } from 'topojson-client'
import { geoMercator, geoPath } from 'd3'
import { Loader } from '@vzmi/shp_shared_compo'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import safeAwait from '../../../../../lib/safeAwait'
import { Error } from '../../../Common/StatePage'
import styles from './TaiwanMaps.css'

const projection = geoMercator()
  .center([123, 24])
  .scale(5500)

const Maps = ({ memberAnalysesData }) => {
  const [mapData, setGeographies] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [fetchError, setFetchError] = useState(false)
  const loadTaiwanMaps = useCallback(async () => {
    setIsLoading(true)
    const [reqError, payload = {}] = await safeAwait(
      // refer to https://ithelp.ithome.com.tw/articles/10223786 compressed to topojson for better performance
      fetch(`${CDN}/file/COUNTY_MOI_1090820.json`)
        .then(response => {
          if (response.status !== 200) {
            console.log(`There was a problem: ${response.status}`)
            setFetchError(true)
            return
          }
          return response.json()
        })
    )
    setIsLoading(false)
    if (!reqError) {
      setGeographies(feature(payload, payload.objects.COUNTY_MOI_1090820).features)
    }
  }, [])

  useEffect(() => {
    loadTaiwanMaps()
  }, [loadTaiwanMaps])
  return (
    <Loader
      loaded={!isLoading}
      className={styles.floatLeft}
    >
      {
        fetchError
          ? (
            <Error
              onClick={loadTaiwanMaps}
              iconType='update'
              text='地圖載入失敗，請稍後再試'
            />
          )
          : (
            <svg
              width='500'
              height='500'
            >
              <g>
                {
                  // draw each country and text for country name
                  // and fill color with alpha from 1 to lighter each times
                  mapData.map((d, i) => {
                    // find matched country data from memberAnalysesData
                    // including country name '台' and '臺' should be the same, ex: '台北市' and '臺北市'
                    const matchedCountry = memberAnalysesData.find(item => item.typeName === d.properties.COUNTYNAME.replace('臺', '台')) || {}
                    const fill = matchedCountry.fill || '#c9d0ea'
                    return (
                      <path
                        key={ `path-${i}` }
                        d={ geoPath().projection(projection)(d) }
                        className={styles.counties}
                        fill={fill}
                        stroke="#FFFFFF"
                        strokeWidth={ 0.5 }
                      >
                        <title>{d.properties.COUNTYNAME}</title>
                      </path>
                    )
                  })
                }
                {
                  // add text for country name
                  mapData.map((d, i) => (
                    <text
                      key={`text-${i}`}
                      x={geoPath().projection(projection).centroid(d)[0]}
                      y={geoPath().projection(projection).centroid(d)[1]}
                      textAnchor="middle"
                      className={styles.countyLabel}
                    >
                      {d.properties.COUNTYNAME.replace('臺', '台')}
                    </text>
                  ))
                }
              </g>
            </svg>
          )
      }
    </Loader>
  )
}

export default Maps
